"use client"

import { useCallback, useEffect, useState } from 'react'
import {
  readLocaleFromSearchParams,
  resolveInitialLandingLocale,
  storeLandingLocale,
} from '@/lib/marketing-locale'
import type { Landing2Locale } from '@/lib/landing-v2/copy'

/**
 * Landing v2 offers English and Armenian in page; Persian visitors go to /home.
 * The stored value is shared with /landing so a returning visitor keeps their choice.
 */
export function useLanding2Locale() {
  const [locale, setLocaleState] = useState<Landing2Locale>('en')

  useEffect(() => {
    const fromUrl = readLocaleFromSearchParams(window.location.search)
    if (fromUrl) {
      storeLandingLocale(fromUrl)
      setLocaleState(fromUrl)
      return
    }

    setLocaleState(resolveInitialLandingLocale() === 'hy' ? 'hy' : 'en')
  }, [])

  const setLocale = useCallback((next: Landing2Locale) => {
    storeLandingLocale(next)
    setLocaleState(next)
  }, [])

  return { locale, setLocale }
}
